import CharacterName from './CharacterName';

export default CharacterName;
export { CharacterName };
